import { namespacer } from 'helpers'

const namespace = namespacer('SELECT_UNIVERSITY')

export const UPDATE_SEARCH_TERM = namespace('UPDATE_SEARCH_TERM')
